import {t} from "i18next";

export const detailPages = ["tournaments", "clubs", "players", "locations", "ratings", "profile"];

export const sports = [{'id': 1, 'name': 'Tennis'}, {'id': 2, 'name': 'Paddle'}]
export const VALID_EXTENSIONS = ["jpg", "jpeg", "png"];
export const grades = [
    {id: 1, name: "Singles"},
    {id: 2, name: "Doubles"},
    {id: 3, name: "Team"}
];

export const genders = [
    {id: 1, name: "Male"},
    {id: 2, name: "Female"},
    {id: 3, name: "Admixed"},
    ]

export const getGradeName = gradeId => {
    const grade = grades.find(g => g.id === gradeId);
    return grade ? t(grade.name) : "";
};

export const COUNTRY_OPTIONS = [
    { id: "AF", name: "Afghanistan"},
    { id: "AL", name: "Albania"},
    { id: "DZ", name: "Algeria"},
    { id: "AS", name: "American Samoa"},
    { id: "AD", name: "Andorra"},
    { id: "AO", name: "Angola"},
    { id: "AI", name: "Anguilla"},
    { id: "AQ", name: "Antarctica"},
    { id: "AG", name: "Antigua and Barbuda"},
    { id: "AR", name: "Argentina"},
    { id: "AM", name: "Armenia"},
    { id: "AW", name: "Aruba"},
    { id: "AU", name: "Australia"},
    { id: "AT", name: "Austria"},
    { id: "AZ", name: "Azerbaijan"},

    { id: "BS", name: "Bahamas"},
    { id: "BH", name: "Bahrain"},
    { id: "BD", name: "Bangladesh"},
    { id: "BB", name: "Barbados"},
    { id: "BE", name: "Belgium"},
    { id: "BZ", name: "Belize"},
    { id: "BJ", name: "Benin"},
    { id: "BM", name: "Bermuda"},
    { id: "BT", name: "Bhutan"},
    { id: "BO", name: "Bolivia"},
    { id: "BA", name: "Bosnia and Herzegovina"},
    { id: "BW", name: "Botswana"},
    { id: "BR", name: "Brazil"},
    { id: "BN", name: "Brunei"},
    { id: "BG", name: "Bulgaria"},
    { id: "BF", name: "Burkina Faso"},
    { id: "BI", name: "Burundi"},

    { id: "KH", name: "Cambodia"},
    { id: "CM", name: "Cameroon"},
    { id: "CA", name: "Canada"},
    { id: "CV", name: "Cape Verde"},
    { id: "CF", name: "Central African Republic"},
    { id: "TD", name: "Chad"},
    { id: "CL", name: "Chile"},
    { id: "CN", name: "China"},
    { id: "CO", name: "Colombia"},
    { id: "KM", name: "Comoros"},
    { id: "CG", name: "Congo"},
    { id: "CD", name: "Congo (DRC)"},
    { id: "CR", name: "Costa Rica"},
    { id: "HR", name: "Croatia"},
    { id: "CY", name: "Cyprus"},
    { id: "CZ", name: "Czech Republic"},

    { id: "DK", name: "Denmark"},
    { id: "DJ", name: "Djibouti"},
    { id: "DM", name: "Dominica"},
    { id: "DO", name: "Dominican Republic"},

    { id: "EC", name: "Ecuador"},
    { id: "EG", name: "Egypt"},
    { id: "SV", name: "El Salvador"},
    { id: "GQ", name: "Equatorial Guinea"},
    { id: "ER", name: "Eritrea"},
    { id: "EE", name: "Estonia"},
    { id: "ET", name: "Ethiopia"},

    { id: "FI", name: "Finland"},
    { id: "FR", name: "France"},

    { id: "GE", name: "Georgia"},
    { id: "DE", name: "Germany"},
    { id: "GH", name: "Ghana"},
    { id: "GR", name: "Greece"},

    { id: "HU", name: "Hungary"},

    { id: "IN", name: "India"},
    { id: "ID", name: "Indonesia"},
    { id: "IR", name: "Iran"},
    { id: "IQ", name: "Iraq"},
    { id: "IE", name: "Ireland"},
    { id: "IL", name: "Israel"},
    { id: "IT", name: "Italy"},

    { id: "JP", name: "Japan"},

    { id: "KZ", name: "Kazakhstan"},
    { id: "KE", name: "Kenya"},
    { id: "KR", name: "South Korea"},

    { id: "LV", name: "Latvia"},
    { id: "LT", name: "Lithuania"},

    { id: "MX", name: "Mexico"},

    { id: "NL", name: "Netherlands"},
    { id: "NO", name: "Norway"},

    { id: "PL", name: "Poland"},
    { id: "PT", name: "Portugal"},

    { id: "RO", name: "Romania"},

    { id: "SA", name: "Saudi Arabia"},
    { id: "RS", name: "Serbia"},
    { id: "SK", name: "Slovakia"},
    { id: "SI", name: "Slovenia"},
    { id: "ES", name: "Spain"},
    { id: "SE", name: "Sweden"},
    { id: "CH", name: "Switzerland"},

    { id: "TR", name: "Turkey"},

    { id: "UA", name: "Ukraine"},
    { id: "GB", name: "United Kingdom"},
    { id: "US", name: "United States"},
];

export const LEVEL_OPTIONS = [
    { id: 1, name: "Pro" },
    { id: 2, name: "Am" },
    // { id: 3, name: "Semi" },
    // { id: 4, name: "Senior" },
    // { id: 5, name: "Junior" },
    // { id: 6, name: "Beginner" },
    // { id: 7, name: "Coach" },
];

export const TEAM_SIZE_OPTIONS = Array.from({ length: 9 }, (_, i) => {
    const v = i + 2;
    return { id: v, name: v.toString() };
});

export const Block = {
    INFO: 1,
    PARTICIPANTS: 2,
    GROUPS: 3,
    DRAWS: 4,
    SCHEDULE: 5,
    MATCHES: 6,
    RANKING: 7,
};

export const gamesOptions = [
    { id: 1, name: "1 set / Standard match" },
    // { id: 2, name: "1 set / Fast 4" },
    // { id: 3, name: "1 set / to 5 games" },
    // { id: 4, name: "Pro Set / to 8 games" },
    // { id: 5, name: "Tiebreak match 10/15/21" },
    { id: 6, name: "2 of 3 / Standard match" },
    // { id: 7, name: "2 of 3 + Match TB10" },
    // { id: 8, name: "3 of 5 / standard" },
    // { id: 9, name: "3 of 5 / no final tiebreak" },
    // { id: 10, name: "Custom" },
]

export const participantsOptions = [2,4,8,16,32,64,128].map(v => ({
    id: v,
    name: String(v)
}));

export function getWeekdayShort(date, locale = "uk-UA") {
    if (!date) return "";
    try {
        const dateObj = date instanceof Date ? date : new Date(date);
        if (isNaN(dateObj.getTime())) return "";
        const day = new Intl.DateTimeFormat(locale, { weekday: "short" }).format(dateObj);
        return day.charAt(0).toUpperCase() + day.slice(1);
    } catch (e) {
        return "";
    }
}

export function formatDateDDMM(date) {
    if (!date) return "";
    try {
        const dateObj = date instanceof Date ? date : new Date(date);
        if (isNaN(dateObj.getTime())) return "";
        const day = String(dateObj.getDate()).padStart(2, "0");
        const month = String(dateObj.getMonth() + 1).padStart(2, "0");
        return `${day}.${month}`;
    } catch (e) {
        return "";
    }
}

export function groupCharCode(number) {
    return String.fromCharCode(64 + number)
}

export function getRoundTitle(r, total, t, i18n, match_order, show_last_order=true) {
    if (r === total) return t("Final");

    if (i18n?.language === "en") {
        if (r === total - 1) return `${t("SF")}${show_last_order ? `-${match_order}` : ""}`;
        if (r === total - 2) return `${t("QF")}${show_last_order ? `-${match_order}` : ""}`;
        return `R${r}${show_last_order ? `-${match_order}` : ""}`;
    }
    return `1/${2 ** (total - r)}${show_last_order ? `-${match_order}` : ""}`;
}

export function getGroupRounds(totalPlayers) {
    const n = totalPlayers || 0;
    if (n < 2) return new Map();

    const hasBye = n % 2 !== 0;
    const size = hasBye ? n + 1 : n;
    const rounds = size - 1;
    const half = size / 2;

    let arr = Array.from({ length: size }, (_, i) => i + 1);
    const map = new Map();

    for (let r = 1; r <= rounds; r++) {
        for (let k = 0; k < half; k++) {
            const a = arr[k];
            const b = arr[size - 1 - k];
            if (a <= n && b <= n) {
                map.set(`${Math.min(a, b)}-${Math.max(a, b)}`, r);
            }
        }
        const fixed = arr[0];
        const rest = arr.slice(1);
        rest.unshift(rest.pop());
        arr = [fixed, ...rest];
    }
    return map;
}

export function getGroupRoundNumber(totalPlayers, matchOrder) {
    const n = totalPlayers || 0;
    if (!n || !matchOrder) return null;

    let order = 1;
    for (let i = 1; i <= n; i++) {
        for (let j = i + 1; j <= n; j++, order++) {
            if (order === matchOrder) {
                return getGroupRounds(n).get(`${i}-${j}`) || null;
            }
        }
    }
    return null;
}

export function getSmallRoundTitle(r, total, t, i18n, match_order, show_last_order=true) {
    if (r === total) return t("F");

    if (i18n?.language === "en") {
        if (r === total - 1) return `${t("SF")}${show_last_order ? `-${match_order}` : ""}`;
        if (r === total - 2) return `${t("QF")}${show_last_order ? `-${match_order}` : ""}`;
        return `R${r}${show_last_order ? `-${match_order}` : ""}`;
    }
    return `1/${2 ** (total - r)}${show_last_order ? `-${match_order}` : ""}`;
}

export const MatchStatus = {
    1: "Expected",
    2: "Warm-up",
    3: "In progress",
    4: "Match stopped",
    5: "Match retired",
    6: "Match walkover",
    7: "Completed",
};

export const getOrdinalSuffix = (number) => {
    if (!number) return t("th");
    const j = number % 10;
    const k = number % 100;
    if (j === 1 && k !== 11) return t("st");
    if (j === 2 && k !== 12) return t("nd");
    if (j === 3 && k !== 13) return t("rd");
    return t("th");
};

export const formatSets = (match) =>
    (match.sets || []).map(set => {
        if (
            (set.game_score_1 !== null && set.game_score_2 === null) ||
            (set.game_score_1 === null && set.game_score_2 !== null)
        ) {
            return "";
        }

        let p1 = set.game_score_1 ?? (match.winner_side === 1 ? "+" : "-");
        let p2 = set.game_score_2 ?? (match.winner_side === 2 ? "+" : "-");

        if (set.tiebreak_score_1 || set.tiebreak_score_2) {
            if (set.game_score_1 < set.game_score_2) p1 += `(${set.tiebreak_score_1})`;
            else p2 += `(${set.tiebreak_score_2})`;
        }

        const isNum = v => /^\d+/.test(String(v));

        return `${p1}${isNum(p1) && isNum(p2) ? "-" : ""}${p2}`;
    }).join(" ");

export const formatSetsWinner = (match) =>
    (match.sets || []).map(set => {
        if (
            (set.game_score_1 !== null && set.game_score_2 === null) ||
            (set.game_score_1 === null && set.game_score_2 !== null)
        ) {
            return "";
        }

        let p1 = set.game_score_1 ?? (match.winner_side === 1 ? "+" : "-");
        let p2 = set.game_score_2 ?? (match.winner_side === 2 ? "+" : "-");

        if (set.tiebreak_score_1 || set.tiebreak_score_2) {
            if (set.game_score_1 < set.game_score_2) p1 += `(${set.tiebreak_score_1})`;
            else p2 += `(${set.tiebreak_score_2})`;
        }

        if (match.winner_side === 2) {
            [p1, p2] = [p2, p1];
        }

        const isNum = v => /^\d+/.test(String(v));

        return `${p1}${isNum(p1) && isNum(p2) ? "-" : ""}${p2}`;
    }).join(" ");

export const handleItemClick = (player, history, location) => {
    if (!player) return;
    const pId = (typeof player === "number" || typeof player === "string")
        ? player
        : (player.player_id || player.id || player.pk);
    if (!pId) return;
    const params = new URLSearchParams(location.search);
    params.set("player_id", pId);
    history.push({ search: params.toString() });
};

// Shared by the pair/team "who's in this slot" menu (Групи/Сітки/Розклад) -
// one entry per player, each linking to that player's own profile overlay.
export const buildProfileAction = (player, history, location) => ({
    icon: "user",
    label: `${player?.first_name ? player.first_name[0] + ". " : ""}${formatLastName(player?.last_name)}`,
    onClick: () => handleItemClick(player, history, location)
});

export const getTeamName = (team, t, fallbackNumber = "") => {
    if (!team) return "";
    if (team.name) return team.name;
    const num = team.number || fallbackNumber;
    return `${t("Team")} ${num}`.trim();
};

export const getInitials = (name) => {
    const words = (name || "").trim().split(" ").filter(Boolean);

    if (words.length === 0) return "";
    if (words.length === 1) {
        return words[0].slice(0, 2).toUpperCase();
    }

    return (words[0][0] + words[1][0]).toUpperCase();
};

export const formatLastName = (name) => {
    if (!name || typeof name !== "string") return name;
    return name.toLowerCase().replace(/(^|[- ])\S/g, l => l.toUpperCase());
};

export const getGuestTokenConfig = (tournamentId, extraHeaders = {}) => {
    const config = { headers: { ...extraHeaders } };
    const tokens = JSON.parse(localStorage.getItem("guest_tokens") || "{}");
    if (tokens[tournamentId]) {
        config.headers['X-Tournament-Token'] = tokens[tournamentId];
    }
    return config;
};

export const renderPlayerInfo = (player, is_authorized) => {
    if (!player) return t(is_authorized ? "Add player" : "Player");
    const lastName = player.last_name || "";
    const shortLastName = lastName.length > 10 ? `${lastName.slice(0, 10)}...` : lastName;
    return (
        <div>
            <span className="uppercase no-laptop">{shortLastName}</span>
            <br />
            {player.first_name}
        </div>
    );
};

export const Truncated = ({ text, max = 10 }) =>
    text?.length > max ? <span style={{letterSpacing: "-0.5px"}}>{text.slice(0, max)}…</span> : <>{text}</>;

export const TruncatedCut = ({ text, max = 8 }) => {
    if (!text || text.length <= max) return <>{text}</>;
    const start = text.slice(0, max - 2);
    const end = text.slice(-2);
    return <>{start}…{end}</>;
};
